export default "__VITE_ASSET__DI_ro1a4__"